import { ApiError, ApiRequestConfig, ApiResponse } from './types';

// const baseURL: string = import.meta.env.VITE_API_URL;
const LOGIN_PAGE = '/login';
const API_ROOT = '/api';
const CHECK_AUTH_API = `${API_ROOT}/auth/check`;
const CABINET_PATH = '/cabinet';

export const errorHandler = (err: ApiError) => {
  console.error('[Error handler]:', err);
  console.error(err);

  if (err.response?.status === 401) {
    // todo: redirect to login page OR show login model

    localStorage.removeItem(import.meta.env.VITE_TOKEN_NAME);
    localStorage.removeItem(import.meta.env.VITE_TOKEN_TTL);

    const isAuthCheckAPI = String(err.config.url).includes(CHECK_AUTH_API);
    const path = window.location.pathname;

    if (!path.startsWith(CABINET_PATH)) {
      console.log('ok');
    } else if (isAuthCheckAPI) {
      window.location.replace(LOGIN_PAGE);
    } else {
      window.location.replace(LOGIN_PAGE);
    }
  }

  return Promise.reject(err);
};

export const requestHandler = (config: ApiRequestConfig) => {
  const headers = config.headers || {};
  const tokenValue = localStorage.getItem(import.meta.env.VITE_TOKEN_NAME);
  const tokenTTL = localStorage.getItem(import.meta.env.VITE_TOKEN_TTL);
  const lang = localStorage.getItem('lang');

  if (tokenValue && tokenTTL && !headers.Authorization) {
    if (new Date(JSON.parse(tokenTTL)) > new Date()) {
      headers.Authorization = JSON.parse(tokenValue);
    }
  }

  const params = { ...config.params, lang: lang || 'ru' };

  return { ...config, headers, params };
};

export const createAuthenticatedRequestHandler = (token: string) => (config: ApiRequestConfig) => {
  const headers = config.headers || {};

  headers.Authorization = token;

  return { ...config, headers };
};

export const responseHandler = (res: ApiResponse) => {
  return res.data;
};
